
import { defineComponent, computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import DateFiltering from './date-filtering.vue'
import { IStoreType } from '@/store/types'
import { IarchivesType } from '@/store/page-file/types'
import '@/assets/font/iconfont'
import { useRouter } from 'vue-router'
import PageCategory from '@/components/page-file/src/page-category.vue'
import CpnRanking from '@/components/cpn/cpn-ranking.vue'
export default defineComponent({
  props: ['category_l'],
  components: {
    DateFiltering,
    PageCategory,
    CpnRanking
  },
  setup(props, context) {
    // 获取阅读数
    type FooFnType = (list: IarchivesType[]) => number
    const readNum = computed<FooFnType>(() => (list) => {
      return Object.values(list).reduce((pre: any, cur) => {
        return pre + cur.read
      }, 0)
    })
    const store = useStore<IStoreType>()
    const categoryList = computed(() => {
      return store.state.pageFileModule.archives
    })
    // 数据优化
    let archives = ref<IarchivesType[]>([])
    let optimize = (lists: IarchivesType[]) => {
      let ls = JSON.parse(JSON.stringify(lists))
      let keysSorted = Object.keys(ls).sort((a, b) => {
        return a < b ? 1 : -1
      })
      let ll: any = {}
      for (let i = 0; i < keysSorted.length; i++) {
        ll[keysSorted[i]] = ls[keysSorted[i] as any]
      }
      archives.value = ll
    }
    // 点击全部文章
    let isShows_ss = ref(false)
    let allArticles = () => {
      activeC.value = 1
      context.emit('activeCs')
      isShows_ss.value = true
      optimize(categoryList.value)
    }
    // 时间筛选文章
    let isShow = ref(false)
    let articlesFn = (v: IarchivesType[]) => {
      if (v) {
        archives.value = v
        activeC.value = 2
      }
      context.emit('activeCs')
      isShow.value = false
      isShows_ss.value = true
    }
    // 点击高亮
    let activeC = ref(1)

    watch([categoryList, () => props.category_l], (n) => {
      if (typeof n[1] == 'object') {
        if (!Object.keys(n[1]).length) {
          optimize(n[0])
        } else {
          optimize(n[1])
          activeC.value = 3
        }
      } else {
        optimize(n[0])
      }
    })
    onMounted(() => {
      if (!Object.keys(categoryList.value).length) {
        // 调用初始数据接口
        store.dispatch('pageFileModule/onFile')
      } else {
        optimize(categoryList.value)
      }
    })
    // 跳转页面
    const router = useRouter()
    const onRouter = (_id: string) => {
      let routeUrl = router.resolve({
        path: `details`,
        query: { id: _id }
      })
      window.open(routeUrl.href, '_blank')
    }
    // 标签分类
    function Category(list: IarchivesType[]) {
      activeC.value = 3
      optimize(list)
    }
    let bq = ref(false)
    return {
      archives,
      readNum,
      allArticles,
      articlesFn,
      categoryList,
      isShow,
      activeC,
      onRouter,
      aa: window.document.body.offsetWidth,
      Category,
      isShows_ss,
      bq
    }
  }
})
